<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Ingrese el plazo
          </v-card-title>
  
          <v-card-text> 
            <p>Plazo establecido para la presentacion de documentos faltantes:</p>
            <v-text-field label="Plazo de entrega:" v-model="fecha_inicio"  type="date" prefix="hasta el:" hide-details />
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false,
            fecha_inicio: {}, 
            resolvePromise: null,
        };
    },
    methods: {
        async openmodal(p) { 
          this.proy = p
          this.dialog = true; 
          this.hoy()
          return new Promise((resolve) => {
              this.resolvePromise = resolve;
          });
        },
        hoy(){
          const fechaActual = new Date(); 
          const año = fechaActual.getFullYear();
          const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); 
          const dia = String(fechaActual.getDate()).padStart(2, '0'); 
          const fechaFormateada = `${año}-${mes}-${dia}`;
          this.fecha_inicio = fechaFormateada;
        }, 

        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        enviar(){ 
            if(!this.fecha_inicio) return 
            const fs = this.fecha_inicio.split('-')
            this.resolvePromise(`${fs[2]} / ${fs[1]} / ${fs[0]}`);
            this.dialog = false;
        }
    }
};
</script>
  